import { ResponsivePie } from '@nivo/pie'
import type React from 'react'
import type { OrdersByProductDto } from '../../../../../../types/coreApi-types'
import { formatNumber } from '../../../../../../utils/formatters'

interface OrdersByProductChartProps {
  data: OrdersByProductDto[]
}

const OrdersByProductChart: React.FC<OrdersByProductChartProps> = ({
  data,
}) => {
  const chartData = data.map(item => ({
    id: item.currencyName,
    label: `${item.currencyName} (${item.currencyIsoCode})`,
    value: item.orderCount,
    totalVolume: item.totalVolume,
    percentage: item.percentageOfTotal,
  }))

  return (
    <div className="h-[400px]">
      <ResponsivePie
        data={chartData}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: 'color',
          modifiers: [['darker', 2]],
        }}
        tooltip={({ datum }) => (
          <div className="bg-white p-3 shadow-lg rounded-lg border border-gray-200">
            <div className="font-semibold">{datum.label}</div>
            <div className="text-sm text-gray-600">Orders: {datum.value}</div>
            <div className="text-sm text-gray-600">
              Volume:{' '}
              {formatNumber(datum.data.totalVolume, {
                currencyType: 'FiatCurrency',
                isoCode: 'EUR',
              })}
            </div>
            <div className="text-sm font-medium text-gray-800">
              {datum.data.percentage.toFixed(2)}% of total
            </div>
          </div>
        )}
        colors={{ scheme: 'nivo' }}
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: 'circle',
          },
        ]}
      />
    </div>
  )
}

export default OrdersByProductChart
